export const INBOUND_ORDER_TYPES = [
    'PURCHASE_ORDER',
    'TRANSFER_ORDER',
    'SALES_ORDER_RETURN',
];
//# sourceMappingURL=inbound-order-type.js.map